import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IntersectionObserverEntryComponent } from './intersection-observer-entry.component';

@NgModule({
  imports: [CommonModule],
  providers: [],
  declarations: [IntersectionObserverEntryComponent],
  exports: [IntersectionObserverEntryComponent],
})
export class RtUIIntersectionObserverModule {}

export {
  provideIntersectionObserverArea,
  IntersectionObserverArea,
  IntersectionObserverAreaConfig,
} from './intersection-observer-area';
export {
  IntersectionObserverEntryComponent,
  IntersectionObserverTemplateContext,
} from './intersection-observer-entry.component';
